var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIoPerson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "#0060C7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "react-icons/io5/IoPerson",
    transform: "translate(4, 3) scale(0.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.2934 2.77492C13.4572 1.87215 12.2893 1.375 11.0002 1.375C9.70431 1.375 8.53255 1.86914 7.70025 2.76633C6.85892 3.6734 6.449 4.90617 6.54525 6.23734C6.73603 8.86359 8.7345 11 11.0002 11C13.266 11 15.261 8.86402 15.4548 6.2382C15.5524 4.91906 15.1399 3.68887 14.2934 2.77492ZM18.5627 20.625H3.43775C3.23977 20.6276 3.04372 20.586 2.86384 20.5033C2.68396 20.4205 2.52479 20.2987 2.3979 20.1468C2.11861 19.8129 2.00603 19.357 2.08939 18.8959C2.45204 16.8841 3.58384 15.1942 5.36275 14.0078C6.94314 12.9546 8.94505 12.375 11.0002 12.375C13.0554 12.375 15.0574 12.9551 16.6377 14.0078C18.4167 15.1938 19.5484 16.8837 19.9111 18.8955C19.9945 19.3566 19.8819 19.8125 19.6026 20.1463C19.4757 20.2984 19.3166 20.4203 19.1367 20.5031C18.9568 20.5859 18.7608 20.6275 18.5627 20.625Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIoPerson);
export default __webpack_public_path__ + "static/media/IoPerson.12177e2f645835005f004ef075e705c4.svg";
export { ForwardRef as ReactComponent };